<template>
    <b-button
        tag="a"
        :href="document.SignedUrl"
        icon-left="cloud-download-alt"
    >
        Download
    </b-button>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true,
        },
    },
};
</script>
